import { GameState } from "../enum/GameState";
import GameObject from "../lib/GameObject";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import Transform from "../lib/Transform";
import Vector2 from "../math/Vector2";
import { clamp01 } from "../util";
import Color from "../util/Color";
import GameManager from "./GameManager";

export default class SPTrail extends MonoBehavior {

    points: {
        positions: [Vector2, Vector2];
        time: number;
    }[] = [];
    color = Color.fromHex("#ffffff");

    isDisabled = false;

    LateUpdate(): void {
        if (this.isDisabled) return;
        const lastPt = this.points[this.points.length - 1];
        const p1 = this.transform.position.add(this.transform.right.rotate(Math.PI/4).scale(8));
        const p2 = this.transform.position.add(this.transform.left.rotate(-Math.PI/4).scale(8));

        if (!lastPt) {
            
            this.points.push({
                positions: [p1.clone(), p2.clone()],
                time: 1
            });
            return;
        }

        if (Vector2.distance(this.transform.position, lastPt.positions[0]) > 4) {
            this.points.push({
                positions: [p1.clone(), p2.clone()],
                time: 1
            });
        }

        for (let i = this.points.length - 1; i >= 0; i--) {
            const pt = this.points[i];
            pt.time -= Time.deltaTime;

            if (pt.time <= 0) {
                this.points.splice(i, 1);
            }
        }
    }

    Draw(): void {
        if (this.points.length < 2) return;

        this.ctx.lineWidth = 1;

        for (let i = 0; i < this.points.length - 1; i++) {
            const pt = this.points[i];
            const next = this.points[i+1];

            if (Vector2.distance(pt.positions[0], next.positions[0]) > 16) continue;
            const alpha = clamp01(pt.time/1);
            this.ctx.strokeStyle = this.color.toHexWithAlpha(alpha);
            this.engine.Line(pt.positions[0], next.positions[0]);

            if (Vector2.distance(pt.positions[1], next.positions[1]) > 16) continue;
            const alpha2 = clamp01(pt.time/1);
            this.ctx.strokeStyle = this.color.toHexWithAlpha(alpha2);
            this.engine.Line(pt.positions[1], next.positions[1]);
        }
    }
    
    DrawGizmos(): void {
        this.engine.drawTextsWorldPosition(
            [
                `${this.points.length.toLocaleString()} trail segments`
            ],
            this.transform.position.add(new Vector2(-16, 16)),
            {
                align: 'right',
                color: this.engine.viewport.fColor
            }
        );
    }

}